/** Preferences key for the pending inbound share payload. */
export const PENDING_SHARE_PREFS_KEY = 'apexx.pendingShare';

/** Filesystem directory (under Directory.Data) for durable shared files. */
export const PENDING_SHARE_FS_ROOT = 'pending-shares';

/** Match chat TUS client upload limit. */
export const MAX_SHARE_FILE_BYTES = 200 * 1024 * 1024;

/** Match chat SendMessage tus_file_ids max. */
export const MAX_SHARE_FILES = 25;

/** Discard pending shares older than this. */
export const PENDING_SHARE_TTL_MS = 24 * 60 * 60 * 1000;

/** App Group used by the iOS Share Extension and Capgo plugin. */
export const SHARE_APP_GROUP_ID = 'group.in.rabatteries.gold';

/** Hub route opened after a share is accepted (embedded chat). */
export const SHARE_TO_CHAT_PATH = '/apps/chat/share';
